export default "__VITE_ASSET__F5MwPa1P__"